var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.breadcrumb)?_c('div',{staticClass:"portal-content--bread-crumbs bread-crumbs d-flex align-items-center"},[_c('b-button',{staticClass:"crumb",attrs:{"variant":"link","to":_vm.breadcrumb.path}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":['far', 'arrow-left']}}),_vm._v(_vm._s(_vm.breadcrumb.text)+" ")],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }